/**
 * Created by jiachenpan on 16/11/18.
 */
import $api_ys from '@/api/getApi';
import Vue from 'vue';

export function formatActivityDate(endTime) {
  let goTime = endTime;
  let timeData = new Date().getTime(); //当前系统时间戳
  let Difference = goTime - timeData;
  let day = '00',
    hour = '00',
    Minute = '00',
    Second = '00';
  if (Difference) {
    //获取有几天
    day = parseInt(Difference / (24 * 60 * 60 * 1000));
    //获取有几个小时
    hour = parseInt((Difference - day * (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
    //获取有几分钟
    Minute = parseInt(
      (Difference - (day * (24 * 60 * 60 * 1000) + hour * (60 * 60 * 1000))) / (60 * 1000)
    );
    //获取秒
    Second = parseInt(
      (Difference - (day * (24 * 60 * 60 * 1000) + hour * (60 * 60 * 1000) + Minute * (60 * 1000))) / 1000
    );
  }

  let obj = {
    day: day,
    hour: hour,
    Minute: Minute,
    Second: Second
  };

  if (obj.day < 10) {
    obj.day = '0' + obj.day;
  }
  if (obj.hour < 10) {
    obj.hour = '0' + obj.hour;
  }
  if (obj.Minute < 10) {
    obj.Minute = '0' + obj.Minute;
  }
  if (obj.Second < 10) {
    obj.Second = '0' + obj.Second;
  }
  return obj;
}
//unit.js
export async function getOpenId(wx_code) {
  return new Promise((resolve, reject) => {
    if (wx_code) {
      $api_ys.javaPost('/user/get_open_id', {
        js_code: wx_code
      }).then(response => {
        const {
          code,
          data
        } = response.data;
        if (code === 0 && data) {
          localStorage.setItem('wxUserData', data);
          resolve()
        } else {
          reject()
        }
      })
    } else {
      // localStorage.setItem('wxUserData', '1');
    }
  })

}
export function errImg(e) {
  e.target.src = require('@/assets/default_image.png');
}
export function get_appid() {
  return 'wxb8692e7a94295b97' //公司
}
export function getWxCode() {
  //微信第三方登录
  //如果之前登录失败了，那么这个code 肯定是存在且为1；，失败的话就不要再请求了 。
  let window_url = window.location.href;
  let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?' +
    'appid=' + get_appid() + '&redirect_uri=' + encodeURIComponent(window_url) + '&response_type=code&scope=snsapi_base&state=' +
    new Date().getTime() + '#wechat_redirect';
  window.location.replace(url);
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

export function sort(arr) {
  for (let i = 0; i < arr.length - 1; i++) {
    for (let j = 0; j < arr.length - 1 - i; j++) {
      if (arr[j].value <= arr[j + 1].value) {
        let temp = arr[j];
        arr[j] = arr[j + 1];
        arr[j + 1] = temp;
      }
    }
  }
  return arr;
}

export function NumFilter(num) {
  // 万 过滤器
  if (num) {
    num = typeof num === 'string' ? Number(num) : num;
    if (num / 10000 >= 1) {
      num = num / 10000 + 'W';
    }
    return num;
  }
}
export function filterNum(num) {
  //数值保持两位小数点
  if (!num) {
    num = 0;
  }
  let num_type = typeof num === 'string' ? Number(num) : num;
  return (num_type ? num_type.toFixed(2) : num_type);
}

export async function setUseInfo(user_token) {
  if (!user_token) {
    let user = localStorage.getItem('user');
    if (user) {
      user = JSON.parse(user);
      user_token = user.memberDto.user_token;
    }
  }
  const response = await $api_ys.javaGet('/user/get_user_info', {
    userToken: user_token
  });
  if (response === false) return;
  if (response.data.code === 0) {
    let userData = response.data.data;
    let user = {
      memberDto: userData,
      user_token: user_token
    };
    localStorage.setItem('user', JSON.stringify(user));
    return JSON.stringify(user);
  }
}

export function formatTime(time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

export async function get_agent_info(invitationCode, level, isSavePath) {
  const response = await $api_ys.javaGet('/agent_change/get_details');
  if (response.data.code === 0) {
    // 说明有签约信息
    Vue.$vux.toast.text('该账户存在签约记录，请下载app查看进度', 'middle');
    setTimeout(() => {
      if (isSavePath) {
        window.location.href = '/treeManager';
      } else {
        window.location.replace('/treeManager');
      }
    }, 1000)
  } else {
    // 没有签约信息
    let source = sessionStorage.getItem('apply_source') || 0;
    if (isSavePath) {
      window.location.href = '/enterApply/tips?apply_source=' + source + '&apply_level=' + level + '&invitationCode=' + invitationCode;
    } else {
      window.location.replace('/enterApply/tips?apply_source=' + source + '&apply_level=' + level + '&invitationCode=' + invitationCode);
    }
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf('?') + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 *  去除前后空格
 * */
export function Trim(str) {
  return str.replace(/(^\s*)|(\s*$)/g, '');
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0;
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/ig) != null) {
      len += 1;
    } else {
      len += 0.5;
    }
  }
  return Math.floor(len);
}

export function cleanArray(actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

export function param(json) {
  if (!json) return '';
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' +
      encodeURIComponent(json[key]);
  })).join('&');
}

export function param2Obj(url) {
  const search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}

export async function getUserInfo() {
  const response = await this.$api_ys.getApi('/test/oss/user/get_user_info/');
  if (response === false) return;
  let userData = response.data.V;
  localStorage.setItem('user', JSON.stringify(userData));
}

export function scrollTo(element, to, duration) {
  if (duration <= 0) return;
  const difference = to - element.scrollTop;
  const perTick = difference / duration * 10;
  setTimeout(() => {
    element.scrollTop = element.scrollTop + perTick;
    if (element.scrollTop === to) return;
    scrollTo(element, to, duration - 10);
  }, 10);
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

export function order_statusFn(status) {
  let msg = '';
  status = typeof status === 'string' ? Number(status) : status;
  if (status === 0) {
    msg = '待确认...';
  } else if (status === 1) {
    msg = '待付款...';
  } else if (status === 2) {
    msg = '待发货...';
  } else if (status === 3) {
    msg = '待收货...';
  } else if (status === 4) {
    msg = '已完成...';
  } else if (status === 5) {
    msg = '已取消...';
  } else {
    msg = '订单状态异常...';
  }
  return msg;
}

export function vermicelli_management_type(type) {
  /**
   *    1代表官方合作伙伴 2 代表区域  3代表一级  4代表二级 5代表特约 0 代表会员
   * **/
  type = typeof type === 'string' ? Number(type) : type;
  const list = [{
      code: 1,
      name: '官方合作伙伴'
    },
    {
      code: 2,
      name: '区域'
    },
    {
      code: 3,
      name: '一级'
    },
    {
      code: 4,
      name: '城市经理'
    },
    {
      code: 5,
      name: '特约'
    },
    {
      code: 0,
      name: '会员'
    }
  ];
  return list.find((item) => {
    return item.code === type;
  });
}

// 是否是微信登录
export function is_weixn() {
  let ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

// 登陆后页面跳转path
export function is_invitation_skip() {
  let shareData = localStorage.getItem('shareData'); //邀请信息
  let user = localStorage.getItem('user'); //用户信息
  let fullPathList = localStorage.getItem('fullPathList'); //需要跳转回登陆之前的信息
  localStorage.removeItem('fullPathList');
  let url = '';
  /**
   *  shareData == >  表示分享链接传入的地址信息 包含token 和 type
   *  type：4邀请城市经理、5邀请特约经销商、6邀请美容顾问、0邀请会员、为空表示分享商品链接
   * **/
  if (shareData) {
    shareData = JSON.parse(shareData);
    let type = typeof shareData.type === 'number' ? shareData.type : Number(shareData.type);
    if (type === 4 || type === 5 || type === 6) {
      //经销商跳签约相关
      if (user) {
        user = JSON.parse(user);
      }
      let agent_level = user.memberDto.agent_level;
      if (!agent_level) {
        /**
         *  存在token 而且又不是经销商身份  签约流程走起来
         * **/
        get_agent_info(shareData.invitationCode, type);
      } else {

        /**
         *  存在token 而且又是经销商身份  首页
         * **/
        url = '/';
      }
      // } else if (type === 6) {
      //   //跳超级会员
      //   if (fullPathList) {
      //     url = fullPathList;
      //   } else {
      //     url = '/';
      //   }
    } else if (type === 0) {
      /**
       *  因为是邀请普通会员前台不需要做业务
       * */
      if (fullPathList) {
        url = fullPathList;
      } else {
        url = '/';
      }
    } else {
      if (shareData.goodsId) {
        //跳商品地址 ====> 一般跳不过来，中间页判断就拦截掉并跳转走了，做容错处理、以防万一，小心总没错！
        url = '/product/details?goods_id=' + shareData.goodsId;
      } else {
        url = '/';
      }

    }
  } else if (fullPathList) {
    url = fullPathList;
  } else {
    url = '/';
  }
  localStorage.removeItem('shareData'); // 销毁邀请信息
  return url;
}

export function clientType() {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  return isAndroid ? 'android' : isiOS ? 'ios' : ''
}

export function order_refund_status(status) {
  let msg = '';
  status = typeof status === 'string' ? Number(status) : status;
  if (status === 0) {
    msg = '待处理';
  } else if (status === 1) {
    msg = '待退货';
  } else if (status === 2) {
    msg = '退货中';
  } else if (status === 3) {
    msg = '待退款';
  } else if (status === 4) {
    msg = '待收款';
  } else if (status === 5) {
    msg = '已完成';
  } else if (status === 6) {
    msg = '已拒绝';
  } else if (status === 7) {
    msg = '已取消';
  } else {
    msg = '订单状态异常...';
  }
  return msg;
}

export function OrderType(type) {
  type = typeof type === 'string' ? Number(type) : type;
  let msg = '';
  if (type === 0) {
    msg = '待确认';
  } else if (type === 1) {
    msg = '待付款';
  } else if (type === 2) {
    msg = '待发货';
  } else if (type === 3) {
    msg = '待收货';
  } else if (type === 4) {
    msg = '已完成';
  } else if (type === 5) {
    msg = '订单已取消';
  } else {
    msg = '订单状态异常...';
  }
  return msg;
}

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone');
  }
  const targetObj = source.constructor === Array ? [] : {};
  for (const keys in source) {
    if (source.hasOwnProperty(keys)) {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = source[keys].constructor === Array ? [] : {};
        targetObj[keys] = deepClone(source[keys]);
      } else {
        targetObj[keys] = source[keys];
      }
    }
  }
  return targetObj;
}

export function getStringTime(day) {
  const d = new Date();
  const t = d.getTime() - day * 24 * 3600 * 1000;
  d.setTime(t);
  return d;
}
//隐藏手机中间四位
export function hideMobile(phone) {
  if (phone) {
    return phone.slice(0, 3) + '****' + phone.slice(-4);
  }
}
// 邮箱格式   例如：35480231@qq.com 转化成 354***1@qq.com
export function regEmail(email) {
  if (String(email).indexOf('@') > 0) {
    var str = email.split('@'),
      _s = '';
    var strLen = str[0].length;
    if (strLen > 4) {
      _s = str[0].substring(0, str[0].length - 4)
    }
    _s += '****';
    var new_email = _s + '@' + str[1]
  }
  return new_email
}

//银行卡前12位加密
export function hideBankNum(bankNum) {
  if (bankNum) {
    return '****' + '     ' + '****' + '        ' + '****' + '        ' + bankNum.slice(-4);
  }
}

export async function  signGetCertification (contractType,func,otherParams={}) {
  let apply_id = sessionStorage.getItem("apply_id");
  if (!apply_id) {
     const result = await $api_ys.javaGet('/agent_change/get_details')
      if (result.code == 0 && result.data.data) {
        sessionStorage.setItem("apply_id", result.data.data.apply_id);
        apply_id = result.data.data.apply_id;
      }
  }
  $api_ys.javaPost("/settleIn/certificationSigning", {
    apply_id,
    contractType:contractType,
    ...otherParams
  })
  .then((res) => {
    console.log(res);
    
    if (res.code == 0 && res.data.data && res.data.data.userSignUrl) {
      sessionStorage.setItem("signContractType", contractType);
      if (func &&  typeof func === 'function') {
        func(res.data.data.userSignUrl)
      }else{
        window.location.href = res.data.data.userSignUrl;
      }
    } else if (res.data.code == -1) {
      Vue.$vux.toast.text('未获取到跳转地址,请联系客服 ', 'middle');
    } else {
      Vue.$vux.toast.text(res.data.msg || '未获取到跳转地址,请联系客服 ', 'middle');
    }
  });
}


// WEBPACK FOOTER //
// ./src/utils/index.js